import { Browser } from "@capacitor/browser";
import { APP_V2_USER_EVENTS, logEvent } from "@src/appV2/lib/analytics";
import { TextButton } from "@src/appV2/redesign/components/TextButton";
import { SupportArticles, type SupportContext } from "@src/appV2/support/constants";
import { type ReactElement } from "react";

import { useSupportLinks } from "./hooks/useSupportLinks";

interface ContactSupportTextButtonProps {
  supportContext: SupportContext;
  children?: React.ReactNode;
  underline?: boolean;
  size?: "small" | "medium" | "large";
}

export function ContactSupportTextButton({
  supportContext,
  children = "24/7 support team",
  underline = true,
  size = "large",
}: ContactSupportTextButtonProps): ReactElement {
  const { howToContactSupportLink } = useSupportLinks();

  return (
    <TextButton
      underline={underline}
      size={size}
      onClick={async () => {
        await Browser.open({
          url: howToContactSupportLink,
          presentationStyle: "popover",
          windowName: "_blank",
        });
        logEvent(APP_V2_USER_EVENTS.OPENED_SUPPORT_ARTICLE, {
          articleLink: howToContactSupportLink,
          articleName: SupportArticles.HOW_TO_CONTACT_SUPPORT,
          supportContext,
        });
      }}
    >
      {children}
    </TextButton>
  );
}
